const marketCap = {
  NULSBNB: {
    currency: "BNB",
    sector: "Nuls",
    name: "Nuls/BNB",
  },
  BNBBTC: {
    currency: "Bitcoin",
    sector: "BNB",
    name: "BNB/Bitcoin",
    market_cap: 13137147,
  },
  NULSBTC: {
    currency: "Bitcoin",
    sector: "Nuls",
    name: "Nuls/Bitcoin",
    market_cap: 97704,
  },
  NEOBTC: {
    currency: "Bitcoin",
    sector: "NEO",
    name: "NEO/Bitcoin",
    market_cap: 2150413,
  },
  NULSETH: {
    currency: "Ethereum",
    sector: "Nuls",
    name: "Nuls/Ethereum",
  },
  LINKBTC: {
    currency: "Bitcoin",
    sector: "ChainLink",
    name: "ChainLink/Bitcoin",
    market_cap: 6761315,
  },
  IOTABTC: {
    currency: "Bitcoin",
    sector: "MIOTA",
    name: "MIOTA/Bitcoin",
    market_cap: 2063268,
  },
  ETCBTC: {
    currency: "Bitcoin",
    sector: "Ethereum Classic",
    name: "Ethereum Classic/Bitcoin",
    market_cap: 13593193,
  },
  ASTETH: {
    currency: "Ethereum",
    sector: "AirSwap",
    name: "AirSwap/Ethereum",
  },
  KNCBTC: {
    currency: "Bitcoin",
    sector: "KyberNetwork",
    name: "KyberNetwork/Bitcoin",
    market_cap: 247765,
  },
  WTCBTC: {
    currency: "Bitcoin",
    sector: "Walton",
    name: "Walton/Bitcoin",
    market_cap: 3366213,
  },
  SNGLSBTC: {
    currency: "Bitcoin",
    sector: "Breaker",
    name: "Breaker/Bitcoin",
    market_cap: 197920,
  },
  EOSETH: {
    currency: "Ethereum",
    sector: "EOS",
    name: "EOS/Ethereum",
    market_cap: 386767,
  },
  SNTETH: {
    currency: "Ethereum",
    sector: "Status",
    name: "Status/Ethereum",
  },
  MCOETH: {
    currency: "Ethereum",
    sector: "MCO",
    name: "MCO/Ethereum",
    market_cap: 40229,
  },
  BTCUSDT: {
    currency: "TetherUS",
    sector: "Bitcoin",
    name: "Bitcoin/TetherUS",
    market_cap: 373668260,
  },
  OAXETH: {
    currency: "Ethereum",
    sector: "openANX",
    name: "openANX/Ethereum",
  },
  OMGETH: {
    currency: "Ethereum",
    sector: "OmiseGO",
    name: "OmiseGO/Ethereum",
  },
  GASBTC: {
    currency: "Bitcoin",
    sector: "NeoGas",
    name: "NeoGas/Bitcoin",
    market_cap: 122635,
  },
  BQXETH: {
    currency: "Ethereum",
    sector: "Voyager",
    name: "Voyager/Ethereum",
    market_cap: 32165,
  },
  WTCETH: {
    currency: "Ethereum",
    sector: "Walton",
    name: "Walton/Ethereum",
    market_cap: 147420,
  },
  QTUMETH: {
    currency: "Ethereum",
    sector: "Qtum",
    name: "Qtum/Ethereum",
    market_cap: 33669,
  },
  BNTETH: {
    currency: "Ethereum",
    sector: "Bancor",
    name: "Bancor/Ethereum",
  },
  DNTETH: {
    currency: "Ethereum",
    sector: "district0x",
    name: "district0x/Ethereum",
  },
  SNMBTC: {
    currency: "Bitcoin",
    sector: "SONM",
    name: "SONM/Bitcoin",
    market_cap: 350058,
  },
  SNMETH: {
    currency: "Ethereum",
    sector: "SONM",
    name: "SONM/Ethereum",
  },
  BQXBTC: {
    currency: "Bitcoin",
    sector: "Voyager",
    name: "Voyager/Bitcoin",
    market_cap: 1276322,
  },
  NEOETH: {
    currency: "Ethereum",
    sector: "NEO",
    name: "NEO/Ethereum",
    market_cap: 112950,
  },
  KNCETH: {
    currency: "Ethereum",
    sector: "KyberNetwork",
    name: "KyberNetwork/Ethereum",
    market_cap: 143173,
  },
  STRATETH: {
    currency: "Ethereum",
    sector: "Stratis",
    name: "Stratis/Ethereum",
    market_cap: 26269,
  },
  ZRXETH: {
    currency: "Ethereum",
    sector: "0x",
    name: "0x/Ethereum",
  },
  QTUMBTC: {
    currency: "Bitcoin",
    sector: "Qtum",
    name: "Qtum/Bitcoin",
    market_cap: 798330,
  },
  FUNETH: {
    currency: "Ethereum",
    sector: "FunFair",
    name: "FunFair/Ethereum",
  },
  LTCBTC: {
    currency: "Bitcoin",
    sector: "Litecoin",
    name: "Litecoin/Bitcoin",
    market_cap: 5579656,
  },
  LINKETH: {
    currency: "Ethereum",
    sector: "ChainLink",
    name: "ChainLink/Ethereum",
    market_cap: 509221,
  },
  ETHBTC: {
    currency: "Bitcoin",
    sector: "Ethereum",
    name: "Ethereum/Bitcoin",
    market_cap: 17708217,
  },
  XVGETH: {
    currency: "Ethereum",
    sector: "Verge",
    name: "Verge/Ethereum",
    market_cap: 27976,
  },
  STRATBTC: {
    currency: "Bitcoin",
    sector: "Stratis",
    name: "Stratis/Bitcoin",
    market_cap: 272545,
  },
  ZRXBTC: {
    currency: "Bitcoin",
    sector: "0x",
    name: "0x/Bitcoin",
    market_cap: 520652,
  },
  IOTAETH: {
    currency: "Ethereum",
    sector: "MIOTA",
    name: "MIOTA/Ethereum",
    market_cap: 174883,
  },
  OMGBTC: {
    currency: "Bitcoin",
    sector: "OmiseGO",
    name: "OmiseGO/Bitcoin",
    market_cap: 262594,
  },
  MCOBTC: {
    currency: "Bitcoin",
    sector: "MCO",
    name: "MCO/Bitcoin",
    market_cap: 169663,
  },
  ADABNB: {
    currency: "BNB",
    sector: "Cardano",
    name: "Cardano/BNB",
    market_cap: 172717,
  },
  ADABTC: {
    currency: "Bitcoin",
    sector: "Cardano",
    name: "Cardano/Bitcoin",
    market_cap: 4156497,
  },
  ADAETH: {
    currency: "Ethereum",
    sector: "Cardano",
    name: "Cardano/Ethereum",
    market_cap: 344690,
  },
  ADAPAX: {
    currency: "Paxos Standard",
    sector: "Cardano",
    name: "Cardano/Paxos Standard",
  },
  ADATUSD: {
    currency: "TrueUSD",
    sector: "Cardano",
    name: "Cardano/TrueUSD",
    market_cap: 75978,
  },
  ADAUSDC: {
    currency: "USD Coin",
    sector: "Cardano",
    name: "Cardano/USD Coin",
    market_cap: 79948,
  },
  ADAUSDT: {
    currency: "TetherUS",
    sector: "Cardano",
    name: "Cardano/TetherUS",
    market_cap: 9111118,
  },
  ADXBTC: {
    currency: "Bitcoin",
    sector: "AdEx",
    name: "AdEx/Bitcoin",
    market_cap: 195312,
  },
  ADXETH: {
    currency: "Ethereum",
    sector: "AdEx",
    name: "AdEx/Ethereum",
  },
  AEBNB: {
    currency: "BNB",
    sector: "Aeternity",
    name: "Aeternity/BNB",
  },
  AEBTC: {
    currency: "Bitcoin",
    sector: "Aeternity",
    name: "Aeternity/Bitcoin",
    market_cap: 118803,
  },
  AEETH: {
    currency: "Ethereum",
    sector: "Aeternity",
    name: "Aeternity/Ethereum",
  },
  AGIBNB: {
    currency: "BNB",
    sector: "SingularityNET",
    name: "SingularityNET/BNB",
  },
  AGIBTC: {
    currency: "Bitcoin",
    sector: "SingularityNET",
    name: "SingularityNET/Bitcoin",
    market_cap: 126845,
  },
  AGIETH: {
    currency: "Ethereum",
    sector: "SingularityNET",
    name: "SingularityNET/Ethereum",
  },
  AIONBNB: {
    currency: "BNB",
    sector: "AION",
    name: "AION/BNB",
    market_cap: 102238,
  },
  AIONBTC: {
    currency: "Bitcoin",
    sector: "AION",
    name: "AION/Bitcoin",
    market_cap: 2868248,
  },
  AIONETH: {
    currency: "Ethereum",
    sector: "AION",
    name: "AION/Ethereum",
    market_cap: 313281,
  },
  ALGOBNB: {
    currency: "BNB",
    sector: "Algorand",
    name: "Algorand/BNB",
    market_cap: 42333,
  },
  ALGOBTC: {
    currency: "Bitcoin",
    sector: "Algorand",
    name: "Algorand/Bitcoin",
    market_cap: 347364,
  },
  ALGOPAX: {
    currency: "Paxos Standard",
    sector: "Algorand",
    name: "Algorand/Paxos Standard",
  },
  ALGOTUSD: {
    currency: "TrueUSD",
    sector: "Algorand",
    name: "Algorand/TrueUSD",
    market_cap: 72893,
  },
  ALGOUSDT: {
    currency: "TetherUS",
    sector: "Algorand",
    name: "Algorand/TetherUS",
    market_cap: 566202,
  },
  AMBBNB: {
    currency: "BNB",
    sector: "Ambrosus",
    name: "Ambrosus/BNB",
  },
  AMBBTC: {
    currency: "Bitcoin",
    sector: "Ambrosus",
    name: "Ambrosus/Bitcoin",
    market_cap: 112485,
  },
  AMBETH: {
    currency: "Ethereum",
    sector: "Ambrosus",
    name: "Ambrosus/Ethereum",
    market_cap: 23231,
  },
  ANKRBNB: {
    currency: "BNB",
    sector: "Ankr",
    name: "Ankr/BNB",
  },
  ANKRBTC: {
    currency: "Bitcoin",
    sector: "Ankr",
    name: "Ankr/Bitcoin",
    market_cap: 30552,
  },
  ANKRUSDT: {
    currency: "TetherUS",
    sector: "Ankr",
    name: "Ankr/TetherUS",
    market_cap: 28988,
  },
  APPCBNB: {
    currency: "BNB",
    sector: "AppCoins",
    name: "AppCoins/BNB",
  },
  APPCBTC: {
    currency: "Bitcoin",
    sector: "AppCoins",
    name: "AppCoins/Bitcoin",
    market_cap: 37646,
  },
  APPCETH: {
    currency: "Ethereum",
    sector: "AppCoins",
    name: "AppCoins/Ethereum",
  },
  ARDRBTC: {
    currency: "Bitcoin",
    sector: "Ardor",
    name: "Ardor/Bitcoin",
  },
  ARDRETH: {
    currency: "Ethereum",
    sector: "Ardor",
    name: "Ardor/Ethereum",
  },
  ARKBTC: {
    currency: "Bitcoin",
    sector: "Ark",
    name: "Ark/Bitcoin",
    market_cap: 60159,
  },
  ARKETH: {
    currency: "Ethereum",
    sector: "Ark",
    name: "Ark/Ethereum",
  },
  ARNBTC: {
    currency: "Bitcoin",
    sector: "Aeron",
    name: "Aeron/Bitcoin",
    market_cap: 613531,
  },
  ARNETH: {
    currency: "Ethereum",
    sector: "Aeron",
    name: "Aeron/Ethereum",
    market_cap: 61948,
  },
  ASTBTC: {
    currency: "Bitcoin",
    sector: "AirSwap",
    name: "AirSwap/Bitcoin",
    market_cap: 80170,
  },
  ATOMBNB: {
    currency: "BNB",
    sector: "Cosmos",
    name: "Cosmos/BNB",
    market_cap: 39482,
  },
  ATOMBTC: {
    currency: "Bitcoin",
    sector: "Cosmos",
    name: "Cosmos/Bitcoin",
    market_cap: 1417053,
  },
  ATOMTUSD: {
    currency: "TrueUSD",
    sector: "Cosmos",
    name: "Cosmos/TrueUSD",
    market_cap: 41389,
  },
  ATOMUSDC: {
    currency: "USD Coin",
    sector: "Cosmos",
    name: "Cosmos/USD Coin",
    market_cap: 56170,
  },
  ATOMUSDT: {
    currency: "TetherUS",
    sector: "Cosmos",
    name: "Cosmos/TetherUS",
    market_cap: 2413668,
  },
  BANDBNB: {
    currency: "BNB",
    sector: "BAND",
    name: "BAND/BNB",
  },
  BANDBTC: {
    currency: "Bitcoin",
    sector: "BAND",
    name: "BAND/Bitcoin",
    market_cap: 132686,
  },
  BANDUSDT: {
    currency: "TetherUS",
    sector: "BAND",
    name: "BAND/TetherUS",
    market_cap: 97610,
  },
  BATBNB: {
    currency: "BNB",
    sector: "Basic Attention Token",
    name: "Basic Attention Token/BNB",
    market_cap: 64786,
  },
  BATBTC: {
    currency: "Bitcoin",
    sector: "Basic Attention Token",
    name: "Basic Attention Token/Bitcoin",
    market_cap: 1294661,
  },
  BATETH: {
    currency: "Ethereum",
    sector: "Basic Attention Token",
    name: "Basic Attention Token/Ethereum",
    market_cap: 56497,
  },
  BATPAX: {
    currency: "Paxos Standard",
    sector: "Basic Attention Token",
    name: "Basic Attention Token/Paxos Standard",
  },
  BATTUSD: {
    currency: "TrueUSD",
    sector: "Basic Attention Token",
    name: "Basic Attention Token/TrueUSD",
  },
  BATUSDC: {
    currency: "USD Coin",
    sector: "Basic Attention Token",
    name: "Basic Attention Token/USD Coin",
  },
  BATUSDT: {
    currency: "TetherUS",
    sector: "Basic Attention Token",
    name: "Basic Attention Token/TetherUS",
    market_cap: 773617,
  },
  BCDBTC: {
    currency: "Bitcoin",
    sector: "Bitcoin Diamond",
    name: "Bitcoin Diamond/Bitcoin",
    market_cap: 611562,
  },
  BCDETH: {
    currency: "Ethereum",
    sector: "Bitcoin Diamond",
    name: "Bitcoin Diamond/Ethereum",
    market_cap: 60398,
  },
  BCPTBNB: {
    currency: "BNB",
    sector: "BlockMason Credit Protocol",
    name: "BlockMason Credit Protocol/BNB",
  },
  BCPTBTC: {
    currency: "Bitcoin",
    sector: "BlockMason Credit Protocol",
    name: "BlockMason Credit Protocol/Bitcoin",
    market_cap: 111243,
  },
  BCPTETH: {
    currency: "Ethereum",
    sector: "BlockMason Credit Protocol",
    name: "BlockMason Credit Protocol/Ethereum",
  },
  BGBPUSDC: {
    currency: "USD Coin",
    sector: "BGBP",
    name: "BGBP/USD Coin",
  },
  BLZBNB: {
    currency: "BNB",
    sector: "Bluzelle",
    name: "Bluzelle/BNB",
  },
  BLZBTC: {
    currency: "Bitcoin",
    sector: "Bluzelle",
    name: "Bluzelle/Bitcoin",
    market_cap: 98367,
  },
  BLZETH: {
    currency: "Ethereum",
    sector: "Bluzelle",
    name: "Bluzelle/Ethereum",
    market_cap: 38579,
  },
  BNBETH: {
    currency: "Ethereum",
    sector: "BNB",
    name: "BNB/Ethereum",
    market_cap: 712448,
  },
  BNBPAX: {
    currency: "Paxos Standard",
    sector: "BNB",
    name: "BNB/Paxos Standard",
    market_cap: 51017,
  },
  BNBTUSD: {
    currency: "TrueUSD",
    sector: "BNB",
    name: "BNB/TrueUSD",
    market_cap: 45364,
  },
  BNBUSDC: {
    currency: "USD Coin",
    sector: "BNB",
    name: "BNB/USD Coin",
    market_cap: 170743,
  },
  BNBUSDS: {
    currency: "StableUSD",
    sector: "BNB",
    name: "BNB/StableUSD",
  },
  BNTBTC: {
    currency: "Bitcoin",
    sector: "Bancor",
    name: "Bancor/Bitcoin",
  },
  BRDBNB: {
    currency: "BNB",
    sector: "Bread",
    name: "Bread/BNB",
  },
  BRDBTC: {
    currency: "Bitcoin",
    sector: "Bread",
    name: "Bread/Bitcoin",
    market_cap: 127364,
  },
  BRDETH: {
    currency: "Ethereum",
    sector: "Bread",
    name: "Bread/Ethereum",
  },
  BTCPAX: {
    currency: "Paxos Standard",
    sector: "Bitcoin",
    name: "Bitcoin/Paxos Standard",
    market_cap: 3143081,
  },
  BTCTUSD: {
    currency: "TrueUSD",
    sector: "Bitcoin",
    name: "Bitcoin/TrueUSD",
    market_cap: 2562842,
  },
  BTCUSDC: {
    currency: "USD Coin",
    sector: "Bitcoin",
    name: "Bitcoin/USD Coin",
    market_cap: 10136113,
  },
  BTCUSDS: {
    currency: "StableUSD",
    sector: "Bitcoin",
    name: "Bitcoin/StableUSD",
  },
  BTGBTC: {
    currency: "Bitcoin",
    sector: "Bitcoin Gold",
    name: "Bitcoin Gold/Bitcoin",
    market_cap: 1541606,
  },
  BTGETH: {
    currency: "Ethereum",
    sector: "Bitcoin Gold",
    name: "Bitcoin Gold/Ethereum",
    market_cap: 52058,
  },
  BTSBTC: {
    currency: "Bitcoin",
    sector: "BitShares",
    name: "BitShares/Bitcoin",
    market_cap: 84994,
  },
  BTSETH: {
    currency: "Ethereum",
    sector: "BitShares",
    name: "BitShares/Ethereum",
  },
  BTTBNB: {
    currency: "BNB",
    sector: "BitTorrent",
    name: "BitTorrent/BNB",
    market_cap: 200299,
  },
  BTTPAX: {
    currency: "Paxos Standard",
    sector: "BitTorrent",
    name: "BitTorrent/Paxos Standard",
    market_cap: 28827,
  },
  BTTTRX: {
    currency: "TRON",
    sector: "BitTorrent",
    name: "BitTorrent/TRON",
    market_cap: 306354,
  },
  BTTTUSD: {
    currency: "TrueUSD",
    sector: "BitTorrent",
    name: "BitTorrent/TrueUSD",
    market_cap: 126246,
  },
  BTTUSDC: {
    currency: "USD Coin",
    sector: "BitTorrent",
    name: "BitTorrent/USD Coin",
    market_cap: 92636,
  },
  BTTUSDT: {
    currency: "TetherUS",
    sector: "BitTorrent",
    name: "BitTorrent/TetherUS",
    market_cap: 3568121,
  },
  CDTBTC: {
    currency: "Bitcoin",
    sector: "Blox",
    name: "Blox/Bitcoin",
    market_cap: 597286,
  },
  CDTETH: {
    currency: "Ethereum",
    sector: "Blox",
    name: "Blox/Ethereum",
    market_cap: 61336,
  },
  CELRBNB: {
    currency: "BNB",
    sector: "Celer Network",
    name: "Celer Network/BNB",
    market_cap: 38812,
  },
  CELRBTC: {
    currency: "Bitcoin",
    sector: "Celer Network",
    name: "Celer Network/Bitcoin",
    market_cap: 360390,
  },
  CELRUSDT: {
    currency: "TetherUS",
    sector: "Celer Network",
    name: "Celer Network/TetherUS",
    market_cap: 162259,
  },
  CHZBNB: {
    currency: "BNB",
    sector: "Chiliz",
    name: "Chiliz/BNB",
  },
  CHZBTC: {
    currency: "Bitcoin",
    sector: "Chiliz",
    name: "Chiliz/Bitcoin",
    market_cap: 277369,
  },
  CHZUSDT: {
    currency: "TetherUS",
    sector: "Chiliz",
    name: "Chiliz/TetherUS",
    market_cap: 101680,
  },
  CMTBNB: {
    currency: "BNB",
    sector: "CyberMiles",
    name: "CyberMiles/BNB",
  },
  CMTBTC: {
    currency: "Bitcoin",
    sector: "CyberMiles",
    name: "CyberMiles/Bitcoin",
    market_cap: 58193,
  },
  CMTETH: {
    currency: "Ethereum",
    sector: "CyberMiles",
    name: "CyberMiles/Ethereum",
  },
  CNDBNB: {
    currency: "BNB",
    sector: "Cindicator",
    name: "Cindicator/BNB",
  },
  CNDBTC: {
    currency: "Bitcoin",
    sector: "Cindicator",
    name: "Cindicator/Bitcoin",
    market_cap: 38555,
  },
  CNDETH: {
    currency: "Ethereum",
    sector: "Cindicator",
    name: "Cindicator/Ethereum",
  },
  COCOSBNB: {
    currency: "BNB",
    sector: "Cocos-BCX",
    name: "Cocos-BCX/BNB",
  },
  COCOSBTC: {
    currency: "Bitcoin",
    sector: "Cocos-BCX",
    name: "Cocos-BCX/Bitcoin",
  },
  COCOSUSDT: {
    currency: "TetherUS",
    sector: "Cocos-BCX",
    name: "Cocos-BCX/TetherUS",
  },
  COSBNB: {
    currency: "BNB",
    sector: "Contentos",
    name: "Contentos/BNB",
  },
  COSBTC: {
    currency: "Bitcoin",
    sector: "Contentos",
    name: "Contentos/Bitcoin",
    market_cap: 124041,
  },
  COSUSDT: {
    currency: "TetherUS",
    sector: "Contentos",
    name: "Contentos/TetherUS",
    market_cap: 35297,
  },
  CVCBTC: {
    currency: "Bitcoin",
    sector: "Civic",
    name: "Civic/Bitcoin",
    market_cap: 63377,
  },
  CVCETH: {
    currency: "Ethereum",
    sector: "Civic",
    name: "Civic/Ethereum",
  },
  CVCUSDT: {
    currency: "TetherUS",
    sector: "Civic",
    name: "Civic/TetherUS",
  },
  DASHBNB: {
    currency: "BNB",
    sector: "Dash",
    name: "Dash/BNB",
    market_cap: 247185,
  },
  DASHBTC: {
    currency: "Bitcoin",
    sector: "Dash",
    name: "Dash/Bitcoin",
    market_cap: 15356784,
  },
  DASHETH: {
    currency: "Ethereum",
    sector: "Dash",
    name: "Dash/Ethereum",
    market_cap: 377905,
  },
  DASHUSDT: {
    currency: "TetherUS",
    sector: "Dash",
    name: "Dash/TetherUS",
    market_cap: 24515570,
  },
  DATABTC: {
    currency: "Bitcoin",
    sector: "Streamr DATAcoin",
    name: "Streamr DATAcoin/Bitcoin",
    market_cap: 982798,
  },
  DATAETH: {
    currency: "Ethereum",
    sector: "Streamr DATAcoin",
    name: "Streamr DATAcoin/Ethereum",
  },
  DCRBNB: {
    currency: "BNB",
    sector: "Decred",
    name: "Decred/BNB",
  },
  DCRBTC: {
    currency: "Bitcoin",
    sector: "Decred",
    name: "Decred/Bitcoin",
    market_cap: 137336,
  },
  DENTETH: {
    currency: "Ethereum",
    sector: "DENT",
    name: "DENT/Ethereum",
  },
  DENTUSDT: {
    currency: "TetherUS",
    sector: "DENT",
    name: "DENT/TetherUS",
  },
  DGDBTC: {
    currency: "Bitcoin",
    sector: "DigixDAO",
    name: "DigixDAO/Bitcoin",
    market_cap: 453364,
  },
  DGDETH: {
    currency: "Ethereum",
    sector: "DigixDAO",
    name: "DigixDAO/Ethereum",
    market_cap: 1423596,
  },
  DLTBNB: {
    currency: "BNB",
    sector: "Agrello",
    name: "Agrello/BNB",
  },
  DLTBTC: {
    currency: "Bitcoin",
    sector: "Agrello",
    name: "Agrello/Bitcoin",
    market_cap: 57132,
  },
  DLTETH: {
    currency: "Ethereum",
    sector: "Agrello",
    name: "Agrello/Ethereum",
  },
  DNTBTC: {
    currency: "Bitcoin",
    sector: "district0x",
    name: "district0x/Bitcoin",
    market_cap: 49545,
  },
  DOCKBTC: {
    currency: "Bitcoin",
    sector: "DOCK",
    name: "DOCK/Bitcoin",
    market_cap: 961778,
  },
  DOCKETH: {
    currency: "Ethereum",
    sector: "DOCK",
    name: "DOCK/Ethereum",
  },
  DOCKUSDT: {
    currency: "TetherUS",
    sector: "DOCK",
    name: "DOCK/TetherUS",
    market_cap: 48592,
  },
  DOGEBNB: {
    currency: "BNB",
    sector: "Dogecoin",
    name: "Dogecoin/BNB",
  },
  DOGEBTC: {
    currency: "Bitcoin",
    sector: "Dogecoin",
    name: "Dogecoin/Bitcoin",
    market_cap: 89017,
  },
  DOGEUSDT: {
    currency: "TetherUS",
    sector: "Dogecoin",
    name: "Dogecoin/TetherUS",
    market_cap: 212561,
  },
  DUSKBNB: {
    currency: "BNB",
    sector: "Dusk Network",
    name: "Dusk Network/BNB",
  },
  DUSKBTC: {
    currency: "Bitcoin",
    sector: "Dusk Network",
    name: "Dusk Network/Bitcoin",
    market_cap: 82664,
  },
  DUSKPAX: {
    currency: "Paxos Standard",
    sector: "Dusk Network",
    name: "Dusk Network/Paxos Standard",
  },
  DUSKUSDC: {
    currency: "USD Coin",
    sector: "Dusk Network",
    name: "Dusk Network/USD Coin",
  },
  DUSKUSDT: {
    currency: "TetherUS",
    sector: "Dusk Network",
    name: "Dusk Network/TetherUS",
    market_cap: 62678,
  },
  EDOBTC: {
    currency: "Bitcoin",
    sector: "Eidoo",
    name: "Eidoo/Bitcoin",
    market_cap: 966548,
  },
  EDOETH: {
    currency: "Ethereum",
    sector: "Eidoo",
    name: "Eidoo/Ethereum",
    market_cap: 65570,
  },
  ELFBTC: {
    currency: "Bitcoin",
    sector: "aelf",
    name: "aelf/Bitcoin",
    market_cap: 128672,
  },
  ELFETH: {
    currency: "Ethereum",
    sector: "aelf",
    name: "aelf/Ethereum",
  },
  ENGBTC: {
    currency: "Bitcoin",
    sector: "Enigma",
    name: "Enigma/Bitcoin",
    market_cap: 229327,
  },
  ENGETH: {
    currency: "Ethereum",
    sector: "Enigma",
    name: "Enigma/Ethereum",
  },
  ENJBNB: {
    currency: "BNB",
    sector: "Enjin Coin",
    name: "Enjin Coin/BNB",
  },
  ENJBTC: {
    currency: "Bitcoin",
    sector: "Enjin Coin",
    name: "Enjin Coin/Bitcoin",
    market_cap: 758122,
  },
  ENJETH: {
    currency: "Ethereum",
    sector: "Enjin Coin",
    name: "Enjin Coin/Ethereum",
    market_cap: 50786,
  },
  ENJUSDT: {
    currency: "TetherUS",
    sector: "Enjin Coin",
    name: "Enjin Coin/TetherUS",
    market_cap: 314789,
  },
  EOSBNB: {
    currency: "BNB",
    sector: "EOS",
    name: "EOS/BNB",
    market_cap: 360323,
  },
  EOSBTC: {
    currency: "Bitcoin",
    sector: "EOS",
    name: "EOS/Bitcoin",
    market_cap: 9962057,
  },
  EOSPAX: {
    currency: "Paxos Standard",
    sector: "EOS",
    name: "EOS/Paxos Standard",
    market_cap: 27242,
  },
  EOSTUSD: {
    currency: "TrueUSD",
    sector: "EOS",
    name: "EOS/TrueUSD",
    market_cap: 35018,
  },
  EOSUSDC: {
    currency: "USD Coin",
    sector: "EOS",
    name: "EOS/USD Coin",
    market_cap: 203904,
  },
  EOSUSDT: {
    currency: "TetherUS",
    sector: "EOS",
    name: "EOS/TetherUS",
    market_cap: 30577220,
  },
  ERDBNB: {
    currency: "BNB",
    sector: "Elrond",
    name: "Elrond/BNB",
  },
  ERDBTC: {
    currency: "Bitcoin",
    sector: "Elrond",
    name: "Elrond/Bitcoin",
    market_cap: 214641,
  },
  ERDUSDT: {
    currency: "TetherUS",
    sector: "Elrond",
    name: "Elrond/TetherUS",
    market_cap: 692278,
  },
  ETCBNB: {
    currency: "BNB",
    sector: "Ethereum Classic",
    name: "Ethereum Classic/BNB",
    market_cap: 163308,
  },
  ETCETH: {
    currency: "Ethereum",
    sector: "Ethereum Classic",
    name: "Ethereum Classic/Ethereum",
    market_cap: 241131,
  },
  ETCUSDT: {
    currency: "TetherUS",
    sector: "Ethereum Classic",
    name: "Ethereum Classic/TetherUS",
    market_cap: 55685556,
  },
  ETHPAX: {
    currency: "Paxos Standard",
    sector: "Ethereum",
    name: "Ethereum/Paxos Standard",
    market_cap: 554859,
  },
  ETHTUSD: {
    currency: "TrueUSD",
    sector: "Ethereum",
    name: "Ethereum/TrueUSD",
    market_cap: 717868,
  },
  ETHUSDC: {
    currency: "USD Coin",
    sector: "Ethereum",
    name: "Ethereum/USD Coin",
    market_cap: 1385427,
  },
  EVXBTC: {
    currency: "Bitcoin",
    sector: "Everex",
    name: "Everex/Bitcoin",
    market_cap: 64320,
  },
  EVXETH: {
    currency: "Ethereum",
    sector: "Everex",
    name: "Everex/Ethereum",
  },
  FETBNB: {
    currency: "BNB",
    sector: "Fetch.AI",
    name: "Fetch.AI/BNB",
    market_cap: 34255,
  },
  FETBTC: {
    currency: "Bitcoin",
    sector: "Fetch.AI",
    name: "Fetch.AI/Bitcoin",
    market_cap: 1334561,
  },
  FETUSDT: {
    currency: "TetherUS",
    sector: "Fetch.AI",
    name: "Fetch.AI/TetherUS",
    market_cap: 1310810,
  },
  FTMBNB: {
    currency: "BNB",
    sector: "Fantom",
    name: "Fantom/BNB",
  },
  FTMBTC: {
    currency: "Bitcoin",
    sector: "Fantom",
    name: "Fantom/Bitcoin",
    market_cap: 259941,
  },
  FTMUSDT: {
    currency: "TetherUS",
    sector: "Fantom",
    name: "Fantom/TetherUS",
    market_cap: 129259,
  },
  FUELBTC: {
    currency: "Bitcoin",
    sector: "Etherparty",
    name: "Etherparty/Bitcoin",
    market_cap: 25265,
  },
  FUNBTC: {
    currency: "Bitcoin",
    sector: "FunFair",
    name: "FunFair/Bitcoin",
  },
  FUNUSDT: {
    currency: "TetherUS",
    sector: "FunFair",
    name: "FunFair/TetherUS",
  },
  GNTBTC: {
    currency: "Bitcoin",
    sector: "Golem",
    name: "Golem/Bitcoin",
    market_cap: 38171,
  },
  GNTETH: {
    currency: "Ethereum",
    sector: "Golem",
    name: "Golem/Ethereum",
  },
  GOBNB: {
    currency: "BNB",
    sector: "GoChain",
    name: "GoChain/BNB",
    market_cap: 33206,
  },
  GOBTC: {
    currency: "Bitcoin",
    sector: "GoChain",
    name: "GoChain/Bitcoin",
    market_cap: 1449593,
  },
  GRSBTC: {
    currency: "Bitcoin",
    sector: "Groestlcoin",
    name: "Groestlcoin/Bitcoin",
    market_cap: 698661,
  },
  GRSETH: {
    currency: "Ethereum",
    sector: "Groestlcoin",
    name: "Groestlcoin/Ethereum",
  },
  GTOBNB: {
    currency: "BNB",
    sector: "Gifto",
    name: "Gifto/BNB",
  },
  GTOBTC: {
    currency: "Bitcoin",
    sector: "Gifto",
    name: "Gifto/Bitcoin",
    market_cap: 140308,
  },
  GTOETH: {
    currency: "Ethereum",
    sector: "Gifto",
    name: "Gifto/Ethereum",
  },
  GTOUSDT: {
    currency: "TetherUS",
    sector: "Gifto",
    name: "Gifto/TetherUS",
    market_cap: 53298,
  },
  GVTBTC: {
    currency: "Bitcoin",
    sector: "Genesis Vision",
    name: "Genesis Vision/Bitcoin",
    market_cap: 37245,
  },
  GVTETH: {
    currency: "Ethereum",
    sector: "Genesis Vision",
    name: "Genesis Vision/Ethereum",
  },
  GXSBTC: {
    currency: "Bitcoin",
    sector: "GXChain",
    name: "GXChain/Bitcoin",
    market_cap: 48429,
  },
  GXSETH: {
    currency: "Ethereum",
    sector: "GXChain",
    name: "GXChain/Ethereum",
  },
  HCBTC: {
    currency: "Bitcoin",
    sector: "HyperCash",
    name: "HyperCash/Bitcoin",
    market_cap: 158304,
  },
  HCETH: {
    currency: "Ethereum",
    sector: "HyperCash",
    name: "HyperCash/Ethereum",
  },
  HOTBNB: {
    currency: "BNB",
    sector: "Holo",
    name: "Holo/BNB",
  },
  HOTBTC: {
    currency: "Bitcoin",
    sector: "Holo",
    name: "Holo/Bitcoin",
    market_cap: 87399,
  },
  HOTETH: {
    currency: "Ethereum",
    sector: "Holo",
    name: "Holo/Ethereum",
    market_cap: 148115,
  },
  HOTUSDT: {
    currency: "TetherUS",
    sector: "Holo",
    name: "Holo/TetherUS",
    market_cap: 477599,
  },
  ICXBNB: {
    currency: "BNB",
    sector: "ICON",
    name: "ICON/BNB",
    market_cap: 42825,
  },
  ICXBTC: {
    currency: "Bitcoin",
    sector: "ICON",
    name: "ICON/Bitcoin",
    market_cap: 361973,
  },
  ICXETH: {
    currency: "Ethereum",
    sector: "ICON",
    name: "ICON/Ethereum",
    market_cap: 45355,
  },
  ICXUSDT: {
    currency: "TetherUS",
    sector: "ICON",
    name: "ICON/TetherUS",
    market_cap: 410746,
  },
  INSBTC: {
    currency: "Bitcoin",
    sector: "Insolar",
    name: "Insolar/Bitcoin",
    market_cap: 631649,
  },
  INSETH: {
    currency: "Ethereum",
    sector: "Insolar",
    name: "Insolar/Ethereum",
    market_cap: 33068,
  },
  IOSTBNB: {
    currency: "BNB",
    sector: "IOST",
    name: "IOST/BNB",
  },
  IOSTBTC: {
    currency: "Bitcoin",
    sector: "IOST",
    name: "IOST/Bitcoin",
    market_cap: 497389,
  },
  IOSTETH: {
    currency: "Ethereum",
    sector: "IOST",
    name: "IOST/Ethereum",
    market_cap: 28549,
  },
  IOSTUSDT: {
    currency: "TetherUS",
    sector: "IOST",
    name: "IOST/TetherUS",
    market_cap: 1667202,
  },
  IOTABNB: {
    currency: "BNB",
    sector: "MIOTA",
    name: "MIOTA/BNB",
    market_cap: 141301,
  },
  IOTAUSDT: {
    currency: "TetherUS",
    sector: "MIOTA",
    name: "MIOTA/TetherUS",
    market_cap: 2104909,
  },
  IOTXBTC: {
    currency: "Bitcoin",
    sector: "IoTeX",
    name: "IoTeX/Bitcoin",
  },
  IOTXETH: {
    currency: "Ethereum",
    sector: "IoTeX",
    name: "IoTeX/Ethereum",
  },
  KEYBTC: {
    currency: "Bitcoin",
    sector: "Selfkey",
    name: "Selfkey/Bitcoin",
  },
  KEYETH: {
    currency: "Ethereum",
    sector: "Selfkey",
    name: "Selfkey/Ethereum",
  },
  KEYUSDT: {
    currency: "TetherUS",
    sector: "Selfkey",
    name: "Selfkey/TetherUS",
    market_cap: 41384,
  },
  KMDBTC: {
    currency: "Bitcoin",
    sector: "Komodo",
    name: "Komodo/Bitcoin",
    market_cap: 133109,
  },
  KMDETH: {
    currency: "Ethereum",
    sector: "Komodo",
    name: "Komodo/Ethereum",
  },
  LENDBTC: {
    currency: "Bitcoin",
    sector: "Aave",
    name: "Aave/Bitcoin",
    market_cap: 4088690,
  },
  LENDETH: {
    currency: "Ethereum",
    sector: "Aave",
    name: "Aave/Ethereum",
    market_cap: 231363,
  },
  LINKPAX: {
    currency: "Paxos Standard",
    sector: "ChainLink",
    name: "ChainLink/Paxos Standard",
    market_cap: 25149,
  },
  LINKTUSD: {
    currency: "TrueUSD",
    sector: "ChainLink",
    name: "ChainLink/TrueUSD",
    market_cap: 115051,
  },
  LINKUSDC: {
    currency: "USD Coin",
    sector: "ChainLink",
    name: "ChainLink/USD Coin",
    market_cap: 77523,
  },
  LINKUSDT: {
    currency: "TetherUS",
    sector: "ChainLink",
    name: "ChainLink/TetherUS",
    market_cap: 11535903,
  },
  LOOMBNB: {
    currency: "BNB",
    sector: "Loom Network",
    name: "Loom Network/BNB",
  },
  LOOMBTC: {
    currency: "Bitcoin",
    sector: "Loom Network",
    name: "Loom Network/Bitcoin",
    market_cap: 82407,
  },
  LOOMETH: {
    currency: "Ethereum",
    sector: "Loom Network",
    name: "Loom Network/Ethereum",
  },
  LRCBTC: {
    currency: "Bitcoin",
    sector: "Loopring",
    name: "Loopring/Bitcoin",
    market_cap: 184044,
  },
  LRCETH: {
    currency: "Ethereum",
    sector: "Loopring",
    name: "Loopring/Ethereum",
    market_cap: 56026,
  },
  LSKBNB: {
    currency: "BNB",
    sector: "Lisk",
    name: "Lisk/BNB",
  },
  LSKBTC: {
    currency: "Bitcoin",
    sector: "Lisk",
    name: "Lisk/Bitcoin",
    market_cap: 232045,
  },
  LSKETH: {
    currency: "Ethereum",
    sector: "Lisk",
    name: "Lisk/Ethereum",
  },
  LTCBNB: {
    currency: "BNB",
    sector: "Litecoin",
    name: "Litecoin/BNB",
    market_cap: 165173,
  },
  LTCETH: {
    currency: "Ethereum",
    sector: "Litecoin",
    name: "Litecoin/Ethereum",
    market_cap: 180079,
  },
  LTCPAX: {
    currency: "Paxos Standard",
    sector: "Litecoin",
    name: "Litecoin/Paxos Standard",
    market_cap: 30732,
  },
  LTCTUSD: {
    currency: "TrueUSD",
    sector: "Litecoin",
    name: "Litecoin/TrueUSD",
    market_cap: 150702,
  },
  LTCUSDC: {
    currency: "USD Coin",
    sector: "Litecoin",
    name: "Litecoin/USD Coin",
    market_cap: 309333,
  },
  LTCUSDT: {
    currency: "TetherUS",
    sector: "Litecoin",
    name: "Litecoin/TetherUS",
    market_cap: 16600280,
  },
  LUNBTC: {
    currency: "Bitcoin",
    sector: "Lunyr",
    name: "Lunyr/Bitcoin",
    market_cap: 68381,
  },
  MANABTC: {
    currency: "Bitcoin",
    sector: "Decentraland",
    name: "Decentraland/Bitcoin",
    market_cap: 272270,
  },
  MANAETH: {
    currency: "Ethereum",
    sector: "Decentraland",
    name: "Decentraland/Ethereum",
  },
  MATICBNB: {
    currency: "BNB",
    sector: "MATIC Network",
    name: "MATIC Network/BNB",
    market_cap: 54702,
  },
  MATICBTC: {
    currency: "Bitcoin",
    sector: "MATIC Network",
    name: "MATIC Network/Bitcoin",
    market_cap: 2779822,
  },
  MATICUSDT: {
    currency: "TetherUS",
    sector: "MATIC Network",
    name: "MATIC Network/TetherUS",
    market_cap: 3624737,
  },
  MCOBNB: {
    currency: "BNB",
    sector: "MCO",
    name: "MCO/BNB",
  },
  MDABTC: {
    currency: "Bitcoin",
    sector: "Moeda Loyalty Points",
    name: "Moeda Loyalty Points/Bitcoin",
    market_cap: 366329,
  },
  MDAETH: {
    currency: "Ethereum",
    sector: "Moeda Loyalty Points",
    name: "Moeda Loyalty Points/Ethereum",
    market_cap: 23662,
  },
  MFTBNB: {
    currency: "BNB",
    sector: "Mainframe",
    name: "Mainframe/BNB",
  },
  MFTBTC: {
    currency: "Bitcoin",
    sector: "Mainframe",
    name: "Mainframe/Bitcoin",
    market_cap: 183042,
  },
  MFTETH: {
    currency: "Ethereum",
    sector: "Mainframe",
    name: "Mainframe/Ethereum",
  },
  MFTUSDT: {
    currency: "TetherUS",
    sector: "Mainframe",
    name: "Mainframe/TetherUS",
    market_cap: 42288,
  },
  MITHBNB: {
    currency: "BNB",
    sector: "Mithril",
    name: "Mithril/BNB",
  },
  MITHBTC: {
    currency: "Bitcoin",
    sector: "Mithril",
    name: "Mithril/Bitcoin",
    market_cap: 40282,
  },
  MITHUSDT: {
    currency: "TetherUS",
    sector: "Mithril",
    name: "Mithril/TetherUS",
  },
  MTHBTC: {
    currency: "Bitcoin",
    sector: "Monetha",
    name: "Monetha/Bitcoin",
    market_cap: 148557,
  },
  MTHETH: {
    currency: "Ethereum",
    sector: "Monetha",
    name: "Monetha/Ethereum",
  },
  MTLBTC: {
    currency: "Bitcoin",
    sector: "Metal",
    name: "Metal/Bitcoin",
    market_cap: 277938,
  },
  MTLETH: {
    currency: "Ethereum",
    sector: "Metal",
    name: "Metal/Ethereum",
    market_cap: 78008,
  },
  MTLUSDT: {
    currency: "TetherUS",
    sector: "Metal",
    name: "Metal/TetherUS",
    market_cap: 170802,
  },
  NANOBNB: {
    currency: "BNB",
    sector: "NANO",
    name: "NANO/BNB",
  },
  NANOBTC: {
    currency: "Bitcoin",
    sector: "NANO",
    name: "NANO/Bitcoin",
    market_cap: 278328,
  },
  NANOETH: {
    currency: "Ethereum",
    sector: "NANO",
    name: "NANO/Ethereum",
    market_cap: 43754,
  },
  NANOUSDT: {
    currency: "TetherUS",
    sector: "NANO",
    name: "NANO/TetherUS",
    market_cap: 110188,
  },
  NASBNB: {
    currency: "BNB",
    sector: "Nebulas",
    name: "Nebulas/BNB",
  },
  NASBTC: {
    currency: "Bitcoin",
    sector: "Nebulas",
    name: "Nebulas/Bitcoin",
    market_cap: 61330,
  },
  NASETH: {
    currency: "Ethereum",
    sector: "Nebulas",
    name: "Nebulas/Ethereum",
  },
  NAVBTC: {
    currency: "Bitcoin",
    sector: "NAV Coin",
    name: "NAV Coin/Bitcoin",
    market_cap: 29024,
  },
  NCASHBTC: {
    currency: "Bitcoin",
    sector: "Nucleus Vision",
    name: "Nucleus Vision/Bitcoin",
    market_cap: 36979,
  },
  NCASHETH: {
    currency: "Ethereum",
    sector: "Nucleus Vision",
    name: "Nucleus Vision/Ethereum",
  },
  NEBLBNB: {
    currency: "BNB",
    sector: "Neblio",
    name: "Neblio/BNB",
  },
  NEBLBTC: {
    currency: "Bitcoin",
    sector: "Neblio",
    name: "Neblio/Bitcoin",
    market_cap: 79095,
  },
  NEBLETH: {
    currency: "Ethereum",
    sector: "Neblio",
    name: "Neblio/Ethereum",
  },
  NEOBNB: {
    currency: "BNB",
    sector: "NEO",
    name: "NEO/BNB",
    market_cap: 53589,
  },
  NEOPAX: {
    currency: "Paxos Standard",
    sector: "NEO",
    name: "NEO/Paxos Standard",
  },
  NEOTUSD: {
    currency: "TrueUSD",
    sector: "NEO",
    name: "NEO/TrueUSD",
    market_cap: 24374,
  },
  NEOUSDC: {
    currency: "USD Coin",
    sector: "NEO",
    name: "NEO/USD Coin",
    market_cap: 50510,
  },
  NEOUSDT: {
    currency: "TetherUS",
    sector: "NEO",
    name: "NEO/TetherUS",
    market_cap: 2946898,
  },
  NPXSETH: {
    currency: "Ethereum",
    sector: "Pundi X",
    name: "Pundi X/Ethereum",
    market_cap: 85992,
  },
  NPXSUSDT: {
    currency: "TetherUS",
    sector: "Pundi X",
    name: "Pundi X/TetherUS",
    market_cap: 166997,
  },
  NULSUSDT: {
    currency: "TetherUS",
    sector: "Nuls",
    name: "Nuls/TetherUS",
    market_cap: 63313,
  },
  NXSBNB: {
    currency: "BNB",
    sector: "Nexus",
    name: "Nexus/BNB",
  },
  NXSBTC: {
    currency: "Bitcoin",
    sector: "Nexus",
    name: "Nexus/Bitcoin",
    market_cap: 22678,
  },
  NXSETH: {
    currency: "Ethereum",
    sector: "Nexus",
    name: "Nexus/Ethereum",
  },
  OAXBTC: {
    currency: "Bitcoin",
    sector: "openANX",
    name: "openANX/Bitcoin",
    market_cap: 68787,
  },
  OMGBNB: {
    currency: "BNB",
    sector: "OmiseGO",
    name: "OmiseGO/BNB",
  },
  OMGUSDT: {
    currency: "TetherUS",
    sector: "OmiseGO",
    name: "OmiseGO/TetherUS",
    market_cap: 245315,
  },
  ONEBNB: {
    currency: "BNB",
    sector: "Harmony",
    name: "Harmony/BNB",
  },
  ONEBTC: {
    currency: "Bitcoin",
    sector: "Harmony",
    name: "Harmony/Bitcoin",
    market_cap: 299937,
  },
  ONEUSDC: {
    currency: "USD Coin",
    sector: "Harmony",
    name: "Harmony/USD Coin",
  },
  ONEUSDT: {
    currency: "TetherUS",
    sector: "Harmony",
    name: "Harmony/TetherUS",
    market_cap: 239313,
  },
  ONGBNB: {
    currency: "BNB",
    sector: "Ontology Gas",
    name: "Ontology Gas/BNB",
  },
  ONGBTC: {
    currency: "Bitcoin",
    sector: "Ontology Gas",
    name: "Ontology Gas/Bitcoin",
    market_cap: 50955,
  },
  ONGUSDT: {
    currency: "TetherUS",
    sector: "Ontology Gas",
    name: "Ontology Gas/TetherUS",
    market_cap: 64329,
  },
  ONTBNB: {
    currency: "BNB",
    sector: "Ontology",
    name: "Ontology/BNB",
    market_cap: 35077,
  },
  ONTBTC: {
    currency: "Bitcoin",
    sector: "Ontology",
    name: "Ontology/Bitcoin",
    market_cap: 741916,
  },
  ONTETH: {
    currency: "Ethereum",
    sector: "Ontology",
    name: "Ontology/Ethereum",
    market_cap: 39542,
  },
  ONTPAX: {
    currency: "Paxos Standard",
    sector: "Ontology",
    name: "Ontology/Paxos Standard",
  },
  ONTUSDT: {
    currency: "TetherUS",
    sector: "Ontology",
    name: "Ontology/TetherUS",
    market_cap: 1942472,
  },
  OSTBNB: {
    currency: "BNB",
    sector: "OST",
    name: "OST/BNB",
  },
  OSTBTC: {
    currency: "Bitcoin",
    sector: "OST",
    name: "OST/Bitcoin",
    market_cap: 39599,
  },
  OSTETH: {
    currency: "Ethereum",
    sector: "OST",
    name: "OST/Ethereum",
  },
  PAXTUSD: {
    currency: "TrueUSD",
    sector: "Paxos Standard",
    name: "Paxos Standard/TrueUSD",
    market_cap: 100037,
  },
  PAXUSDT: {
    currency: "TetherUS",
    sector: "Paxos Standard",
    name: "Paxos Standard/TetherUS",
    market_cap: 2384527,
  },
  PERLBNB: {
    currency: "BNB",
    sector: "Perlin",
    name: "Perlin/BNB",
  },
  PERLBTC: {
    currency: "Bitcoin",
    sector: "Perlin",
    name: "Perlin/Bitcoin",
    market_cap: 132086,
  },
  PERLUSDT: {
    currency: "TetherUS",
    sector: "Perlin",
    name: "Perlin/TetherUS",
    market_cap: 68743,
  },
  PHBBNB: {
    currency: "BNB",
    sector: "Red Pulse Phoenix Binance",
    name: "Red Pulse Phoenix Binance/BNB",
  },
  PHBBTC: {
    currency: "Bitcoin",
    sector: "Red Pulse Phoenix Binance",
    name: "Red Pulse Phoenix Binance/Bitcoin",
    market_cap: 89416,
  },
  PHBTUSD: {
    currency: "TrueUSD",
    sector: "Red Pulse Phoenix Binance",
    name: "Red Pulse Phoenix Binance/TrueUSD",
  },
  PIVXBNB: {
    currency: "BNB",
    sector: "PIVX",
    name: "PIVX/BNB",
  },
  PIVXBTC: {
    currency: "Bitcoin",
    sector: "PIVX",
    name: "PIVX/Bitcoin",
    market_cap: 33782,
  },
  PIVXETH: {
    currency: "Ethereum",
    sector: "PIVX",
    name: "PIVX/Ethereum",
  },
  POABTC: {
    currency: "Bitcoin",
    sector: "POA Network",
    name: "POA Network/Bitcoin",
    market_cap: 28496,
  },
  POAETH: {
    currency: "Ethereum",
    sector: "POA Network",
    name: "POA Network/Ethereum",
  },
  POEBTC: {
    currency: "Bitcoin",
    sector: "Po.et",
    name: "Po.et/Bitcoin",
  },
  POEETH: {
    currency: "Ethereum",
    sector: "Po.et",
    name: "Po.et/Ethereum",
  },
  POLYBNB: {
    currency: "BNB",
    sector: "Polymath",
    name: "Polymath/BNB",
  },
  POLYBTC: {
    currency: "Bitcoin",
    sector: "Polymath",
    name: "Polymath/Bitcoin",
    market_cap: 54854,
  },
  POWRBNB: {
    currency: "BNB",
    sector: "PowerLedger",
    name: "PowerLedger/BNB",
  },
  POWRBTC: {
    currency: "Bitcoin",
    sector: "PowerLedger",
    name: "PowerLedger/Bitcoin",
    market_cap: 40987,
  },
  POWRETH: {
    currency: "Ethereum",
    sector: "PowerLedger",
    name: "PowerLedger/Ethereum",
  },
  PPTBTC: {
    currency: "Bitcoin",
    sector: "Populous",
    name: "Populous/Bitcoin",
    market_cap: 91839,
  },
  PPTETH: {
    currency: "Ethereum",
    sector: "Populous",
    name: "Populous/Ethereum",
  },
  QKCBTC: {
    currency: "Bitcoin",
    sector: "QuarkChain",
    name: "QuarkChain/Bitcoin",
    market_cap: 71615,
  },
  QKCETH: {
    currency: "Ethereum",
    sector: "QuarkChain",
    name: "QuarkChain/Ethereum",
  },
  QLCBTC: {
    currency: "Bitcoin",
    sector: "QLC Chain",
    name: "QLC Chain/Bitcoin",
    market_cap: 325200,
  },
  QLCETH: {
    currency: "Ethereum",
    sector: "QLC Chain",
    name: "QLC Chain/Ethereum",
  },
  QSPBNB: {
    currency: "BNB",
    sector: "Quantstamp",
    name: "Quantstamp/BNB",
  },
  QSPBTC: {
    currency: "Bitcoin",
    sector: "Quantstamp",
    name: "Quantstamp/Bitcoin",
    market_cap: 46833,
  },
  QSPETH: {
    currency: "Ethereum",
    sector: "Quantstamp",
    name: "Quantstamp/Ethereum",
  },
  QTUMBNB: {
    currency: "BNB",
    sector: "Qtum",
    name: "Qtum/BNB",
  },
  QTUMUSDT: {
    currency: "TetherUS",
    sector: "Qtum",
    name: "Qtum/TetherUS",
    market_cap: 2317880,
  },
  RCNBNB: {
    currency: "BNB",
    sector: "Ripio Credit Network",
    name: "Ripio Credit Network/BNB",
  },
  RCNBTC: {
    currency: "Bitcoin",
    sector: "Ripio Credit Network",
    name: "Ripio Credit Network/Bitcoin",
    market_cap: 75580,
  },
  RCNETH: {
    currency: "Ethereum",
    sector: "Ripio Credit Network",
    name: "Ripio Credit Network/Ethereum",
  },
  RDNBNB: {
    currency: "BNB",
    sector: "Raiden Network Token",
    name: "Raiden Network Token/BNB",
  },
  RDNBTC: {
    currency: "Bitcoin",
    sector: "Raiden Network Token",
    name: "Raiden Network Token/Bitcoin",
    market_cap: 797499,
  },
  RDNETH: {
    currency: "Ethereum",
    sector: "Raiden Network Token",
    name: "Raiden Network Token/Ethereum",
    market_cap: 56924,
  },
  RENBNB: {
    currency: "BNB",
    sector: "Ren",
    name: "Ren/BNB",
  },
  RENBTC: {
    currency: "Bitcoin",
    sector: "Ren",
    name: "Ren/Bitcoin",
    market_cap: 164025,
  },
  REPBTC: {
    currency: "Bitcoin",
    sector: "Augur",
    name: "Augur/Bitcoin",
    market_cap: 694291,
  },
  REPETH: {
    currency: "Ethereum",
    sector: "Augur",
    name: "Augur/Ethereum",
    market_cap: 38336,
  },
  REQBTC: {
    currency: "Bitcoin",
    sector: "Request Network",
    name: "Request Network/Bitcoin",
  },
  REQETH: {
    currency: "Ethereum",
    sector: "Request Network",
    name: "Request Network/Ethereum",
  },
  RLCBNB: {
    currency: "BNB",
    sector: "iExecRLC",
    name: "iExecRLC/BNB",
  },
  RLCBTC: {
    currency: "Bitcoin",
    sector: "iExecRLC",
    name: "iExecRLC/Bitcoin",
    market_cap: 205432,
  },
  RLCETH: {
    currency: "Ethereum",
    sector: "iExecRLC",
    name: "iExecRLC/Ethereum",
    market_cap: 30038,
  },
  RVNBNB: {
    currency: "BNB",
    sector: "Ravencoin",
    name: "Ravencoin/BNB",
    market_cap: 22763,
  },
  RVNBTC: {
    currency: "Bitcoin",
    sector: "Ravencoin",
    name: "Ravencoin/Bitcoin",
    market_cap: 1711347,
  },
  SCBNB: {
    currency: "BNB",
    sector: "Siacoin",
    name: "Siacoin/BNB",
  },
  SCBTC: {
    currency: "Bitcoin",
    sector: "Siacoin",
    name: "Siacoin/Bitcoin",
    market_cap: 32750,
  },
  SCETH: {
    currency: "Ethereum",
    sector: "Siacoin",
    name: "Siacoin/Ethereum",
  },
  SKYBNB: {
    currency: "BNB",
    sector: "Skycoin",
    name: "Skycoin/BNB",
    market_cap: 42359,
  },
  SKYBTC: {
    currency: "Bitcoin",
    sector: "Skycoin",
    name: "Skycoin/Bitcoin",
    market_cap: 1607246,
  },
  SKYETH: {
    currency: "Ethereum",
    sector: "Skycoin",
    name: "Skycoin/Ethereum",
    market_cap: 72379,
  },
  SNTBTC: {
    currency: "Bitcoin",
    sector: "Status",
    name: "Status/Bitcoin",
    market_cap: 42081,
  },
  STEEMBNB: {
    currency: "BNB",
    sector: "Steem",
    name: "Steem/BNB",
    market_cap: 46920,
  },
  STEEMBTC: {
    currency: "Bitcoin",
    sector: "Steem",
    name: "Steem/Bitcoin",
    market_cap: 482404,
  },
  STEEMETH: {
    currency: "Ethereum",
    sector: "Steem",
    name: "Steem/Ethereum",
  },
  STORJBTC: {
    currency: "Bitcoin",
    sector: "Storj",
    name: "Storj/Bitcoin",
    market_cap: 59966,
  },
  STORJETH: {
    currency: "Ethereum",
    sector: "Storj",
    name: "Storj/Ethereum",
  },
  STORMBNB: {
    currency: "BNB",
    sector: "Storm",
    name: "Storm/BNB",
  },
  STORMBTC: {
    currency: "Bitcoin",
    sector: "Storm",
    name: "Storm/Bitcoin",
    market_cap: 24449,
  },
  STORMETH: {
    currency: "Ethereum",
    sector: "Storm",
    name: "Storm/Ethereum",
  },
  STORMUSDT: {
    currency: "TetherUS",
    sector: "Storm",
    name: "Storm/TetherUS",
    market_cap: 23776,
  },
  SYSBTC: {
    currency: "Bitcoin",
    sector: "Syscoin",
    name: "Syscoin/Bitcoin",
    market_cap: 32871,
  },
  SYSETH: {
    currency: "Ethereum",
    sector: "Syscoin",
    name: "Syscoin/Ethereum",
  },
  TFUELBNB: {
    currency: "BNB",
    sector: "Theta Fuel",
    name: "Theta Fuel/BNB",
  },
  TFUELBTC: {
    currency: "Bitcoin",
    sector: "Theta Fuel",
    name: "Theta Fuel/Bitcoin",
    market_cap: 74530,
  },
  TFUELUSDT: {
    currency: "TetherUS",
    sector: "Theta Fuel",
    name: "Theta Fuel/TetherUS",
    market_cap: 27319,
  },
  THETABNB: {
    currency: "BNB",
    sector: "Theta Token",
    name: "Theta Token/BNB",
    market_cap: 31437,
  },
  THETABTC: {
    currency: "Bitcoin",
    sector: "Theta Token",
    name: "Theta Token/Bitcoin",
    market_cap: 1694973,
  },
  THETAETH: {
    currency: "Ethereum",
    sector: "Theta Token",
    name: "Theta Token/Ethereum",
    market_cap: 75619,
  },
  THETAUSDT: {
    currency: "TetherUS",
    sector: "Theta Token",
    name: "Theta Token/TetherUS",
    market_cap: 468185,
  },
  TNBBTC: {
    currency: "Bitcoin",
    sector: "Time New Bank",
    name: "Time New Bank/Bitcoin",
  },
  TNBETH: {
    currency: "Ethereum",
    sector: "Time New Bank",
    name: "Time New Bank/Ethereum",
  },
  TNTBTC: {
    currency: "Bitcoin",
    sector: "Tierion",
    name: "Tierion/Bitcoin",
    market_cap: 182283,
  },
  TNTETH: {
    currency: "Ethereum",
    sector: "Tierion",
    name: "Tierion/Ethereum",
  },
  TOMOBNB: {
    currency: "BNB",
    sector: "TomoChain",
    name: "TomoChain/BNB",
  },
  TOMOBTC: {
    currency: "Bitcoin",
    sector: "TomoChain",
    name: "TomoChain/Bitcoin",
    market_cap: 706889,
  },
  TOMOUSDC: {
    currency: "USD Coin",
    sector: "TomoChain",
    name: "TomoChain/USD Coin",
  },
  TOMOUSDT: {
    currency: "TetherUS",
    sector: "TomoChain",
    name: "TomoChain/TetherUS",
    market_cap: 352665,
  },
  TRXBNB: {
    currency: "BNB",
    sector: "TRON",
    name: "TRON/BNB",
    market_cap: 240988,
  },
  TRXBTC: {
    currency: "Bitcoin",
    sector: "TRON",
    name: "TRON/Bitcoin",
    market_cap: 2487625,
  },
  TRXETH: {
    currency: "Ethereum",
    sector: "TRON",
    name: "TRON/Ethereum",
    market_cap: 615870,
  },
  TRXPAX: {
    currency: "Paxos Standard",
    sector: "TRON",
    name: "TRON/Paxos Standard",
    market_cap: 137262,
  },
  TRXTUSD: {
    currency: "TrueUSD",
    sector: "TRON",
    name: "TRON/TrueUSD",
    market_cap: 113234,
  },
  TRXUSDC: {
    currency: "USD Coin",
    sector: "TRON",
    name: "TRON/USD Coin",
    market_cap: 171157,
  },
  TRXUSDT: {
    currency: "TetherUS",
    sector: "TRON",
    name: "TRON/TetherUS",
    market_cap: 10662059,
  },
  TRXXRP: {
    currency: "Ripple",
    sector: "TRON",
    name: "TRON/Ripple",
    market_cap: 167844,
  },
  TUSDUSDT: {
    currency: "TetherUS",
    sector: "TrueUSD",
    name: "TrueUSD/TetherUS",
    market_cap: 3188315,
  },
  USDCPAX: {
    currency: "Paxos Standard",
    sector: "USD Coin",
    name: "USD Coin/Paxos Standard",
    market_cap: 115933,
  },
  USDCTUSD: {
    currency: "TrueUSD",
    sector: "USD Coin",
    name: "USD Coin/TrueUSD",
    market_cap: 165207,
  },
  USDCUSDT: {
    currency: "TetherUS",
    sector: "USD Coin",
    name: "USD Coin/TetherUS",
    market_cap: 5881705,
  },
  USDSUSDT: {
    currency: "TetherUS",
    sector: "StableUSD",
    name: "StableUSD/TetherUS",
  },
  VETBNB: {
    currency: "BNB",
    sector: "VeChain",
    name: "VeChain/BNB",
    market_cap: 27429,
  },
  VETBTC: {
    currency: "Bitcoin",
    sector: "VeChain",
    name: "VeChain/Bitcoin",
    market_cap: 1620498,
  },
  VETETH: {
    currency: "Ethereum",
    sector: "VeChain",
    name: "VeChain/Ethereum",
    market_cap: 161835,
  },
  VETUSDT: {
    currency: "TetherUS",
    sector: "VeChain",
    name: "VeChain/TetherUS",
    market_cap: 3018967,
  },
  VIABNB: {
    currency: "BNB",
    sector: "Viacoin",
    name: "Viacoin/BNB",
  },
  VIABTC: {
    currency: "Bitcoin",
    sector: "Viacoin",
    name: "Viacoin/Bitcoin",
    market_cap: 60123,
  },
  VIAETH: {
    currency: "Ethereum",
    sector: "Viacoin",
    name: "Viacoin/Ethereum",
  },
  VIBBTC: {
    currency: "Bitcoin",
    sector: "Viberate",
    name: "Viberate/Bitcoin",
    market_cap: 561359,
  },
  VIBEBTC: {
    currency: "Bitcoin",
    sector: "VIBE",
    name: "VIBE/Bitcoin",
    market_cap: 40407,
  },
  VIBEETH: {
    currency: "Ethereum",
    sector: "VIBE",
    name: "VIBE/Ethereum",
  },
  VIBETH: {
    currency: "Ethereum",
    sector: "Viberate",
    name: "Viberate/Ethereum",
    market_cap: 61287,
  },
  WABIBNB: {
    currency: "BNB",
    sector: "TAEL",
    name: "TAEL/BNB",
  },
  WABIBTC: {
    currency: "Bitcoin",
    sector: "TAEL",
    name: "TAEL/Bitcoin",
    market_cap: 179374,
  },
  WABIETH: {
    currency: "Ethereum",
    sector: "TAEL",
    name: "TAEL/Ethereum",
  },
  WANBNB: {
    currency: "BNB",
    sector: "Wanchain",
    name: "Wanchain/BNB",
  },
  WANBTC: {
    currency: "Bitcoin",
    sector: "Wanchain",
    name: "Wanchain/Bitcoin",
    market_cap: 364656,
  },
  WANETH: {
    currency: "Ethereum",
    sector: "Wanchain",
    name: "Wanchain/Ethereum",
    market_cap: 59100,
  },
  WANUSDT: {
    currency: "TetherUS",
    sector: "Wanchain",
    name: "Wanchain/TetherUS",
    market_cap: 124480,
  },
  WAVESBNB: {
    currency: "BNB",
    sector: "Waves",
    name: "Waves/BNB",
  },
  WAVESBTC: {
    currency: "Bitcoin",
    sector: "Waves",
    name: "Waves/Bitcoin",
    market_cap: 3100966,
  },
  WAVESETH: {
    currency: "Ethereum",
    sector: "Waves",
    name: "Waves/Ethereum",
    market_cap: 282945,
  },
  WAVESTUSD: {
    currency: "TrueUSD",
    sector: "Waves",
    name: "Waves/TrueUSD",
    market_cap: 33478,
  },
  WAVESUSDC: {
    currency: "USD Coin",
    sector: "Waves",
    name: "Waves/USD Coin",
  },
  WAVESUSDT: {
    currency: "TetherUS",
    sector: "Waves",
    name: "Waves/TetherUS",
    market_cap: 943961,
  },
  WINBNB: {
    currency: "BNB",
    sector: "WINK",
    name: "WINK/BNB",
    market_cap: 234568,
  },
  WINTRX: {
    currency: "TRON",
    sector: "WINK",
    name: "WINK/TRON",
    market_cap: 152931,
  },
  WINUSDC: {
    currency: "USD Coin",
    sector: "WINK",
    name: "WINK/USD Coin",
    market_cap: 135955,
  },
  WINUSDT: {
    currency: "TetherUS",
    sector: "WINK",
    name: "WINK/TetherUS",
    market_cap: 1679813,
  },
  WPRBTC: {
    currency: "Bitcoin",
    sector: "WePower",
    name: "WePower/Bitcoin",
    market_cap: 40554,
  },
  WPRETH: {
    currency: "Ethereum",
    sector: "WePower",
    name: "WePower/Ethereum",
  },
  WTCBNB: {
    currency: "BNB",
    sector: "Walton",
    name: "Walton/BNB",
    market_cap: 82063,
  },
  XEMBNB: {
    currency: "BNB",
    sector: "NEM",
    name: "NEM/BNB",
    market_cap: 35490,
  },
  XEMBTC: {
    currency: "Bitcoin",
    sector: "NEM",
    name: "NEM/Bitcoin",
    market_cap: 535567,
  },
  XEMETH: {
    currency: "Ethereum",
    sector: "NEM",
    name: "NEM/Ethereum",
  },
  XLMBNB: {
    currency: "BNB",
    sector: "Stellar Lumens",
    name: "Stellar Lumens/BNB",
    market_cap: 130687,
  },
  XLMBTC: {
    currency: "Bitcoin",
    sector: "Stellar Lumens",
    name: "Stellar Lumens/Bitcoin",
    market_cap: 7468741,
  },
  XLMETH: {
    currency: "Ethereum",
    sector: "Stellar Lumens",
    name: "Stellar Lumens/Ethereum",
    market_cap: 371352,
  },
  XLMPAX: {
    currency: "Paxos Standard",
    sector: "Stellar Lumens",
    name: "Stellar Lumens/Paxos Standard",
  },
  XLMTUSD: {
    currency: "TrueUSD",
    sector: "Stellar Lumens",
    name: "Stellar Lumens/TrueUSD",
    market_cap: 320021,
  },
  XLMUSDT: {
    currency: "TetherUS",
    sector: "Stellar Lumens",
    name: "Stellar Lumens/TetherUS",
    market_cap: 21235103,
  },
  XMRBNB: {
    currency: "BNB",
    sector: "Monero",
    name: "Monero/BNB",
    market_cap: 28660,
  },
  XMRBTC: {
    currency: "Bitcoin",
    sector: "Monero",
    name: "Monero/Bitcoin",
    market_cap: 3363013,
  },
  XMRETH: {
    currency: "Ethereum",
    sector: "Monero",
    name: "Monero/Ethereum",
    market_cap: 164705,
  },
  XMRUSDT: {
    currency: "TetherUS",
    sector: "Monero",
    name: "Monero/TetherUS",
    market_cap: 1692692,
  },
  XRPBNB: {
    currency: "BNB",
    sector: "Ripple",
    name: "Ripple/BNB",
    market_cap: 301363,
  },
  XRPBTC: {
    currency: "Bitcoin",
    sector: "Ripple",
    name: "Ripple/Bitcoin",
    market_cap: 10701665,
  },
  XRPETH: {
    currency: "Ethereum",
    sector: "Ripple",
    name: "Ripple/Ethereum",
    market_cap: 440638,
  },
  XRPPAX: {
    currency: "Paxos Standard",
    sector: "Ripple",
    name: "Ripple/Paxos Standard",
    market_cap: 64396,
  },
  XRPTUSD: {
    currency: "TrueUSD",
    sector: "Ripple",
    name: "Ripple/TrueUSD",
    market_cap: 145298,
  },
  XRPUSDC: {
    currency: "USD Coin",
    sector: "Ripple",
    name: "Ripple/USD Coin",
    market_cap: 457825,
  },
  XRPUSDT: {
    currency: "TetherUS",
    sector: "Ripple",
    name: "Ripple/TetherUS",
    market_cap: 23857595,
  },
  XVGBTC: {
    currency: "Bitcoin",
    sector: "Verge",
    name: "Verge/Bitcoin",
    market_cap: 201993,
  },
  XZCBNB: {
    currency: "BNB",
    sector: "Zcoin",
    name: "Zcoin/BNB",
    market_cap: 34102,
  },
  XZCBTC: {
    currency: "Bitcoin",
    sector: "Zcoin",
    name: "Zcoin/Bitcoin",
    market_cap: 420482,
  },
  XZCETH: {
    currency: "Ethereum",
    sector: "Zcoin",
    name: "Zcoin/Ethereum",
    market_cap: 32083,
  },
  XZCXRP: {
    currency: "Ripple",
    sector: "Zcoin",
    name: "Zcoin/Ripple",
  },
  YOYOBNB: {
    currency: "BNB",
    sector: "YOYOW",
    name: "YOYOW/BNB",
  },
  YOYOBTC: {
    currency: "Bitcoin",
    sector: "YOYOW",
    name: "YOYOW/Bitcoin",
    market_cap: 31108,
  },
  YOYOETH: {
    currency: "Ethereum",
    sector: "YOYOW",
    name: "YOYOW/Ethereum",
  },
  ZECBNB: {
    currency: "BNB",
    sector: "Zcash",
    name: "Zcash/BNB",
    market_cap: 55172,
  },
  ZECBTC: {
    currency: "Bitcoin",
    sector: "Zcash",
    name: "Zcash/Bitcoin",
    market_cap: 3248492,
  },
  ZECETH: {
    currency: "Ethereum",
    sector: "Zcash",
    name: "Zcash/Ethereum",
    market_cap: 103047,
  },
  ZECPAX: {
    currency: "Paxos Standard",
    sector: "Zcash",
    name: "Zcash/Paxos Standard",
  },
  ZECTUSD: {
    currency: "TrueUSD",
    sector: "Zcash",
    name: "Zcash/TrueUSD",
    market_cap: 136923,
  },
  ZECUSDC: {
    currency: "USD Coin",
    sector: "Zcash",
    name: "Zcash/USD Coin",
  },
  ZECUSDT: {
    currency: "TetherUS",
    sector: "Zcash",
    name: "Zcash/TetherUS",
    market_cap: 8429819,
  },
  ZENBNB: {
    currency: "BNB",
    sector: "Horizen",
    name: "Horizen/BNB",
  },
  ZENBTC: {
    currency: "Bitcoin",
    sector: "Horizen",
    name: "Horizen/Bitcoin",
    market_cap: 256145,
  },
  ZENETH: {
    currency: "Ethereum",
    sector: "Horizen",
    name: "Horizen/Ethereum",
    market_cap: 32921,
  },
  ZILBNB: {
    currency: "BNB",
    sector: "Zilliqa",
    name: "Zilliqa/BNB",
    market_cap: 24397,
  },
  ZILBTC: {
    currency: "Bitcoin",
    sector: "Zilliqa",
    name: "Zilliqa/Bitcoin",
    market_cap: 204786,
  },
  ZILETH: {
    currency: "Ethereum",
    sector: "Zilliqa",
    name: "Zilliqa/Ethereum",
    market_cap: 72998,
  },
  ZILUSDT: {
    currency: "TetherUS",
    sector: "Zilliqa",
    name: "Zilliqa/TetherUS",
    market_cap: 194263,
  },
  ZRXBNB: {
    currency: "BNB",
    sector: "0x",
    name: "0x/BNB",
  },
  ZRXUSDT: {
    currency: "TetherUS",
    sector: "0x",
    name: "0x/TetherUS",
    market_cap: 243350,
  },
  BNBUSDT: {
    currency: "TetherUS",
    sector: "BNB",
    name: "BNB/TetherUS",
    market_cap: 25093665,
  },
  ETHUSDT: {
    currency: "TetherUS",
    sector: "Ethereum",
    name: "Ethereum/TetherUS",
    market_cap: 68143831,
  },
};

export default marketCap;
